import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { AssetAttrsDetails, PipelineConfigAttrs } from "../../interfaces/api";
import { useTriggerProcessing } from "../Orion/OrionQueries";
import { DialogProps } from "./useDialogs";

function ProcessAssetDialog({
  payload,
  open,
  onClose,
}: DialogProps<{
  asset: AssetAttrsDetails;
  config: PipelineConfigAttrs;
}>) {
  const { mutate: triggerProcessing } = useTriggerProcessing();

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Analyser à nouveau le dossier ?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {`Vous êtes sur le point de lancer une analyse de ${payload.asset.name} avec la configuration ${payload.config.name}`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Annuler</Button>
        <Button
          onClick={() => {
            triggerProcessing({
              assetId: payload.asset._id,
              configId: payload.config._id,
            });
            onClose();
          }}
          autoFocus
        >
          Analyser
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ProcessAssetDialog;
